import Web3 from 'web3';
import Env from './env.js';

const TokenContractAbi = require('./contracts/TokenContract.json');
const RaffleDappAbi = require('./contracts/RaffleDapp.json');
const uniswapabi = require('./contracts/uniswap.json');

export async function getWeb3(login) {
    
    if (window.ethereum) {
        const w3 = new Web3(window.ethereum);

        if (login) {
            await window.ethereum.enable();
        }

        return w3;
    } else if (window.web3) {
        return new Web3(window.web3.currentProvider);
    }
}

export function readWeb3() {
    return new Web3(new Web3.providers.HttpProvider(Env.ethNode));
}

export function readWeb32socket() {
    return new Web3(new Web3.providers.WebsocketProvider(Env.ethNodesocket));
}

export function readWeb32() {
    return new Web3(new Web3.providers.HttpProvider(Env.ethNode2));
}

export function readWeb3R() {
    return new Web3(new Web3.providers.HttpProvider(Env.ethNodeR));
}

export function readWeb3Rsocket() {
    return new Web3(new Web3.providers.WebsocketProvider(Env.ethNodeRsocket));
}

export function getRaffleDapp(web3) {
    return web3.eth.Contract(RaffleDappAbi, Env.RaffleDapp);
}

export function getTokenContract(web3) {
    return web3.eth.Contract(TokenContractAbi, Env.TokenContract);
}

export function geterc20contract(web3,address) {
    return web3.eth.Contract(TokenContractAbi, address);
}
export function getunishuf(web3) {
    return web3.eth.Contract(uniswapabi, Env.tokenuniswap);
}

export function getunitoken(web3,token) {
    return web3.eth.Contract(uniswapabi, token);
}

